import { ProblemDetails, ValidationProblemDetails } from "./cplapi/CPLAPI";

// Endpoints that return Result throw ProblemDetails, which has no message, so the error alert would be blank
export const problemDetailsToError = (error: unknown) => {
  if (!(error instanceof ProblemDetails || error instanceof ValidationProblemDetails)) return error;

  const firstValidationError =
    error instanceof ValidationProblemDetails ? Object.values(error.errors ?? {}).flat()[0] : undefined;

  return new Error(firstValidationError ?? error.detail ?? error.title ?? "Something went wrong");
};

export const rethrowAsError = (error: unknown): never => {
  throw problemDetailsToError(error);
};
